import { lazy } from "react";

const LoginPage = lazy(() => import("../pages/LoginPage"));
const LogoutPage = lazy(() => import("../pages/LogoutPage"));
const SettingsPage = lazy(() => import("../pages/SettingsPage"));
const UserManagement = lazy(() => import("../pages/UserManagement"));
const LogbookPage = lazy(() => import("../pages/LogbookPage"));
const LogbookDetailPage = lazy(() => import("../pages/LogbookDetailPage"));
const SubmissionsPage = lazy(() => import("../pages/SubmissionsPage"));
const SubmissionDetailPage = lazy(() =>
  import("../pages/SubmissionDetailPage"),
);
const PDFViewerPage = lazy(() => import("../pages/PDFViewerPage"));
const AllFilesPage = lazy(() => import("../pages/AllFilesPage"));
const TocEditComponent = lazy(() => import("../pages/TocEditComponent"));

export const routeConfig = {
  public: [
    { path: "/login", component: LoginPage },
    { path: "/logout", component: LogoutPage },
    { path: "/pdf-viewer", component: PDFViewerPage },
  ],

  // Routes that get Sidebar only (no chat panel)
  withSidebar: [
    { path: "/admin", component: UserManagement },
    { path: "/logbook", component: LogbookPage },
    { path: "/logbook/:id", component: LogbookDetailPage },
    { path: "/submissions", component: SubmissionsPage },
    { path: "/submissions/:id", component: SubmissionDetailPage },
  ],

  // Routes that get Sidebar + shared AllFiles chat panel via AllFilesChatLayout
  withSidebarAndChat: [
    { path: "/", component: AllFilesPage },
    { path: "/model", component: TocEditComponent },
  ],

  // Protected routes without Sidebar
  protected: [{ path: "/settings", component: SettingsPage }],
};
